export const headers = [
  { name: 'Grupo', field: 'grouped', sortable: true },
  { name: 'Função', field: 'function', sortable: true },
  { name: 'Nome', field: 'name', sortable: true },
  { name: 'Url Base', field: 'base_url', sortable: true },
  { name: 'Caminho', field: 'path', sortable: true },
  { name: 'Ações', field: 'actions', sortable: false }
]
